export function hasPdfSignature(bytes: Uint8Array): boolean {
  return (
    bytes.length >= 5 &&
    bytes[0] === 0x25 &&
    bytes[1] === 0x50 &&
    bytes[2] === 0x44 &&
    bytes[3] === 0x46 &&
    bytes[4] === 0x2d
  );
}

export function looksLikeGuideCsv(sample: string): boolean {
  const header = sample
    .replace(/^\uFEFF/, "")
    .split(/\r?\n/)
    .find((line) => line.trim());
  if (!header || !header.includes(",")) return false;
  const fields = header
    .split(",")
    .map((field) =>
      field.trim().replace(/^"|"$/g, "").toLocaleLowerCase("en-US"),
    );
  return fields.includes("agenda_number") || fields.includes("description");
}
